module.exports = __webpack_public_path__ + "img/play-post-1.cc11b577.jpg";